import { useMutation } from '@tanstack/react-query';

import { GatewayPricingPlan } from 'src/features/gateway/utils/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';
import { PricingPlanObjectFormSchemaValues } from 'src/features/pricing/sites/utils/formSchema';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/sites/gateway-pricing-plan/`;

type MutationFnType = typeof mutationFn;

interface DTO extends PricingPlanObjectFormSchemaValues {
    parkingId: string;
}

const mutationFn = ({ parkingId, ...data}: DTO): Promise<GatewayPricingPlan> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateGatewayPricingPlan };
